import React, { Fragment, useEffect, useState } from "react";
import ButtonComponent from "@/components/button/Button";
import { Col, Divider, Row } from "antd";
import Container from "@/components/container/Container";
import CardComponent from "@/components/card";
import "@/styles/pages/saved-video.scss";
import BackWithLabel from "@/components/common/BackWithLabel";
import PreviewComponent from "@/components/preview/PreviewComponent";
import { sessionsRecordings } from "@/services/users/sessionsRecordings";
import Slider from "react-slick";
import Session from "@/pages/session/Session";
import { DateTime } from "luxon";

const SavedVideo = ({ isGuidePanel = false }) => {
  const [videoRecording, setVideoRecording] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // API call is implemented here; the sample JSON is for reference only.
  const fetchData = async () => {
    try {
      const res = await sessionsRecordings();
      setVideoRecording(res?.rows || []);
    } catch (error) {
      console.error(error);
    }
  };

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  // This helper converts the UTC date and time into the user's local timezone.
  const formatLocalDateTime = (date, time) => {
    const localDateTime = DateTime.fromISO(`${date}T${time}`, {
      zone: "UTC",
    }).toLocal();
    return localDateTime.toFormat("yyyy-LL-dd HH:mm");
  };

  return (
    <Fragment>
      <div className="video-page">
        <Container>
          <CardComponent>
            <div className="options-container">
              <Row>
                <Col span={24}>
                  <div className="heading">
                    <BackWithLabel label="Saved Video" path="/dashboard" />
                  </div>
                </Col>
              </Row>
              {videoRecording.length ? (
                videoRecording.map((data, index) => (
                  <div key={index} style={{ marginBottom: "20px" }}>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <div className="title-h6-1">
                        {data.guideName ? data.name : data.studentName}
                      </div>
                      <div className="flex-1">
                        <Divider />
                      </div>
                    </div>
                    <Row gutter={[24, 16]}>
                      <Col span={24}>
                        <div className="save-video-container">
                          {isMobile ? (
                            <div className="video-carousel">
                              {data.sessions && data.sessions.length > 1 ? (
                                <Slider {...settings}>
                                  {data.sessions.map((session, index) => (
                                    <div key={index}>
                                      <div className="video-section">
                                        <PreviewComponent
                                          img_url={
                                            session.img_url
                                              ? session.img_url
                                              : "data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs="
                                          }
                                          url={session.sessionRecordedUrl}
                                          type="video"
                                        />
                                        <div className="video-label">
                                          <label>
                                            {data.guideName
                                              ? `Guide: ${data.guideName}`
                                              : `Product: ${data.name}`}
                                          </label>
                                          <label>
                                            Date-Time:{" "}
                                            {formatLocalDateTime(session.date, session.time)}
                                          </label>

                                          <div
                                            className=""
                                            style={{
                                              marginTop: "10px",
                                              marginBottom: "4px",
                                              width: "100%",
                                            }}
                                          >
                                            <ButtonComponent
                                              label="View Transcription"
                                              disabled={!session.transcriptionUrl}
                                              iconRight={false}
                                              onClick={() => {
                                                // session.transcriptionUrl
                                                window.open(session.transcriptionUrl, "_blank");
                                              }}
                                              style={{ width: "100%" }}
                                            ></ButtonComponent>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </Slider>
                              ) : (
                                <div className="video-section">
                                  <PreviewComponent
                                    img_url={
                                      data.sessions[0].img_url
                                        ? data.sessions[0].img_url
                                        : "data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs="
                                    }
                                    url={data.sessions[0].sessionRecordedUrl}
                                    type="video"
                                  />
                                  <div className="video-label">
                                    <label>
                                      {data.guideName
                                        ? `Guide: ${data.guideName}`
                                        : `Product: ${data.name}`}
                                    </label>
                                    <label>
                                      Date-Time:{" "}
                                      {formatLocalDateTime(
                                        data.sessions[0].date,
                                        data.sessions[0].time
                                      )}
                                    </label>
                                    <div
                                      className=""
                                      style={{
                                        marginTop: "10px",
                                        marginBottom: "4px",
                                        width: "100%",
                                      }}
                                    >
                                      <ButtonComponent
                                        label="View Transcription"
                                        disabled={!data.sessions[0].transcriptionUrl}
                                        iconRight={false}
                                        onClick={() => {
                                          // session.transcriptionUrl
                                          window.open(data.sessions[0].transcriptionUrl, "_blank");
                                        }}
                                        style={{ width: "100%" }}
                                      ></ButtonComponent>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          ) : (
                            <Row gutter={[16, 24]}>
                              {data.sessions.map((session, index) => (
                                <Col key={index} xxl={6} xl={6} lg={6} md={12} sm={24} xs={24}>
                                  <div className="video-section">
                                    <PreviewComponent
                                      img_url={
                                        session.img_url
                                          ? session.img_url
                                          : "data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs="
                                      }
                                      url={session.sessionRecordedUrl}
                                      type="video"
                                    />
                                    <div className="video-label">
                                      <label>
                                        {data.guideName
                                          ? `Guide: ${data.guideName}`
                                          : `Product: ${data.name}`}
                                      </label>
                                      <label>
                                        Date-Time: {formatLocalDateTime(session.date, session.time)}
                                      </label>
                                      <div
                                        className=""
                                        style={{
                                          marginTop: "10px",
                                          marginBottom: "4px",
                                          width: "100%",
                                        }}
                                      >
                                        <ButtonComponent
                                          label="View Transcription"
                                          disabled={!session.transcriptionUrl}
                                          iconRight={false}
                                          onClick={() => {
                                            // session.transcriptionUrl
                                            window.open(session.transcriptionUrl, "_blank");
                                          }}
                                          style={{ width: "100%" }}
                                        ></ButtonComponent>
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                              ))}
                            </Row>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div>
                ))
              ) : (
                <Session isGuidePanel />
              )}
            </div>
          </CardComponent>
        </Container>
      </div>
    </Fragment>
  );
};

export default SavedVideo;
